
import { createApp } from 'vue'
import SimpleSearchField from './simple-search-field.vue';


document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('simpleSearchField');
    if (!el) return

    const app= createApp(SimpleSearchField);
    app.mount( el );
})

